import {useEffect, useState} from "react";
import DesignService from "../../services/DesignService";
import LinkedText from "../LinkedText";
import IconText from "../IconText";
import {faReddit, faYoutube} from "@fortawesome/free-brands-svg-icons";
import {faCube, faCubes, faArrowUp, faComment, faEye, faThumbsUp} from "@fortawesome/free-solid-svg-icons";

export default function DesignTable() {
    const [designs, setDesigns] = useState([]);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const fetchDesigns = async () => {
            try {
                const data = await DesignService.getAllDesigns();
                setDesigns(data);

                // Fetch Reddit data for each design asynchronously
                for (const design of data) {
                    if (design.reddit_link) {
                        const redditData = await DesignService.getRedditData(design.reddit_link);
                        setDesigns(prevDesigns =>
                            prevDesigns.map(d =>
                                d.id === design.id
                                    ? {...d, ...redditData}
                                    : d
                            )
                        );
                    }
                }

                // Fetch YouTube data for each design asynchronously
                for (const design of data) {
                    if (design.youtube_link) {
                        const youtubeData = await DesignService.getYouTubeData(design.youtube_link);
                        setDesigns(prevDesigns =>
                            prevDesigns.map(d =>
                                d.id === design.id
                                    ? {...d, ...youtubeData}
                                    : d
                            )
                        );
                    }
                }
            } catch (error) {
                console.error("Failed to fetch designs:", error);
            }
        };

        fetchDesigns();
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setIsNarrowScreen(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const imageStyle = {height: '100px', width: '100px', objectFit: 'cover'};
    const titleStyle = {textDecoration: "underline", fontWeight: "bold"};

    return (
        <div>
            <table>
                <thead>
                <tr>
                    <th>Image</th>
                    <th>Design</th>
                    {isNarrowScreen ? (
                        <th>Links</th>
                    ) : (
                        <>
                            <th>MakerWorld</th>
                            <th>Reddit</th>
                            <th>YouTube</th>
                        </>
                    )}
                </tr>
                </thead>
                <tbody>
                {designs.map((design) => (
                    <tr key={design.id}>
                        <td>
                            <img src={design.img_link} alt={design.title} style={imageStyle}/>
                        </td>
                        <td>
                            <div>
                                <div style={titleStyle}>{design.title}</div>
                                <div>{design.description}</div>
                            </div>
                        </td>
                        {isNarrowScreen ? (
                            <td>
                                {design.makerworld_link && (
                                    <>
                                        <LinkedText text={"Download"} href={design.makerworld_link} icon={faCubes}
                                                    customBgColor={"#06AE42"}/>
                                        <br/>
                                        <IconText icon={faCube} text={"3MF"}/>
                                        <IconText icon={faCube} text={"STL"}/>
                                    </>
                                )}
                                {design.reddit_link && (
                                    <>
                                        <LinkedText text={"Discuss"} href={design.reddit_link} icon={faReddit}
                                                    customBgColor={"#FF4500"}/>
                                        <br/>
                                        <IconText icon={faArrowUp} text={design.reddit_score}/>
                                        <IconText icon={faComment} text={design.reddit_comments}/>
                                        <br/>
                                    </>
                                )}
                                {design.youtube_link && (
                                    <>
                                        <LinkedText text={"Watch"} href={design.youtube_link} icon={faYoutube}
                                                    customBgColor={"#FF0000"}/>
                                        <br/>
                                        <IconText icon={faEye} text={design.youtube_views}/>
                                        <IconText icon={faThumbsUp} text={design.youtube_likes}/>
                                    </>
                                )}
                            </td>
                        ) : (
                            <>
                                <td>
                                    {design.makerworld_link && (
                                        <>
                                            <LinkedText text={"Download"} href={design.makerworld_link} icon={faCubes}
                                                        customBgColor={"#06AE42"}/>
                                            <br/>
                                            <IconText icon={faCube} text={"3MF"}/>
                                            <IconText icon={faCube} text={"STL"}/>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {design.reddit_link && (
                                        <>
                                            <LinkedText text={"Discuss"} href={design.reddit_link} icon={faReddit}
                                                        customBgColor={"#FF4500"}/>
                                            <br/>
                                            <IconText icon={faArrowUp} text={design.reddit_score}/>
                                            <IconText icon={faComment} text={design.reddit_comments}/>
                                            <br/>
                                        </>
                                    )}
                                </td>
                                <td>
                                    {design.youtube_link && (
                                        <>
                                            <LinkedText text={"Watch"} href={design.youtube_link} icon={faYoutube}
                                                        customBgColor={"#FF0000"}/>
                                            <br/>
                                            <IconText icon={faEye} text={design.youtube_views}/>
                                            <IconText icon={faThumbsUp} text={design.youtube_likes}/>
                                        </>
                                    )}
                                </td>
                            </>
                        )}
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}
